<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
        Result History
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WMDS</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Result History</a>
          </li>
      </ul>
    </div>
    <!-- <b-card> -->
      <!-- <template slot="header"><i class='fa fa-align-justify'></i>Result History</template> -->
      <!-- detail search start -->
      <!--
        상세 점검 내용
        1. 점검 시작 시간 - 적용됨
        2. 점검 종료 시간 - 적용됨
        3. 점검 총 시간
        4. 탐지 여부 - 적용됨
        5. 에러 여부 - 적용됨
        6. 페이지 여부 - ??
       -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> Inspection Date
                <b-button size="sm" variant="info" @click="set_sd('', 'created_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'created_at')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'created_at')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'created_at')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'created_at')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'created_at')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_visit"> Finished Date
                <b-button size="sm" variant="info" @click="set_sd('', 'finished_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'finished_at')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'finished_at')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'finished_at')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'finished_at')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'finished_at')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.finished_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.finished_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2">
            <b-form-group>
              <label for="opt_error">Error</label><br>
              <c-switch v-if="so.adv" v-model="so.opt.error_count" @change="($event) = so.opt = Object.assign({}, so.opt, { error_count : $event }); refresh()"  color="warning" label variant="pill" />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group>
              <label for="opt_error">Detect</label><br>
              <c-switch v-if="so.adv" v-model="so.opt.detect_count" @change="($event) = so.opt = Object.assign({}, so.opt, { detect_count : $event }); refresh()"  color="danger" label variant="pill" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <label for="ph_search_opt_type">Match Type</label>
            <b-form-group>
              <b-form-radio-group v-model="so.opt.match_type" @change="($event) = so.opt = Object.assign({}, so.opt, { match_type : $event })" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:Match all</b-form-radio>
                <b-form-radio value="or">[OR]:Match at least one</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group class="float-right">
          <b-button class="btn-add" size="sm" variant="success" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-card>
      <!-- detail search end -->

      <b-card>
        <b-row>
          <b-col md="5">
            <span class="text-center" v-b-tooltip.hover title="can see the log real-time">
              Show Count
              <select v-model="so.perPage" @change="refresh">
                <option value="15">Default 15</option>
                <option value=10>10</option>
                <option value=50>50</option>
                <option value=100>100</option>
              </select>
            </span>
          </b-col>
          <b-col sm="5">
            <!-- 여기서 고민되는 부분이 점검 결과에서 어떠한 페이지를 검색 할 것인가임 -->
            <!--
              내가 만약 사용자라면 점검하고 싶은 부분
              1. 점검 실패한 부분이나 탐지된 경우
              2. 특정 페이지 범위
            -->
            <b-input-group size="sm" class="pr-3">
              <b-input-group-append>
                <label class="mr-3" for="opt_detect">Quick Search</label>
              </b-input-group-append>
              <b-input-group-append>
                <label class="mr-3" for="opt_detect">Detect</label>
                <c-switch class="mr-3" :disabled="so.adv"  color="danger" label variant="pill" @change="($event) => { if(loading) { return; } so.sv = $event; so.sk = 'detect_count'; refresh() }" />
              </b-input-group-append>

              <b-input-group-append>
                <label class="mr-3" for="opt_error">Error</label>
                <c-switch class="mr-3" :disabled="so.adv"  color="warning" label variant="pill" @change="($event) => { if(loading) { return; } so.sv = $event; so.sk = 'error_count'; refresh() }"  />
              </b-input-group-append>
            </b-input-group>

          </b-col>
          <b-col sm="1">
            <b-btn block variant="outline-secondary" @click="refresh"><i class="fa fa-refresh"></i></b-btn>
          </b-col>
          <b-col sm="1">
            <b-btn block variant="outline-secondary" @click="search_opt">
              <i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"> Detail Search</i>
            </b-btn>
          </b-col>
        </b-row>
        <hr>

        * <b-badge variant="success">Login Successful </b-badge> or <b-badge variant="warning">Login Failed </b-badge>
        : After logging in from the login page, if it is not 401 Unauthorized or 403 Forbesiden, it will be recorded as successful
        <br>
        * <b-badge variant="primary">Ticket </b-badge>
        : You can copy tickets by pressing FQDN. If there is a problem with the site, you must contact with the ticket to process it quickly.
        <br>
        * <b-badge variant="info">Logged in </b-badge>
        : Displays whether the login settings are used or not.
        <br>
        * <b-badge variant="info">JS Event </b-badge>
        : When you click a link, a JavaScript click event occurs (you can perform a dynamic script that acts as an event occurrence)
        <br>
        * <b-badge variant="success">Safety </b-badge>
        : No malicious code distribution and waypoint detected
        <br>
        * <b-badge variant="danger">Detect </b-badge>
        : There is a detected malicious code distribution and waypoint
        <br>
        * <b-badge variant="warning">Error</b-badge>
        : This is a case where the page failed to the load normally. Pages response status : <a target="_blank" href="https://en.wikipedia.org/wiki/List_of_HTTP_status_codes">400 ~ 500</a>
        <br>
        * <b-badge variant="dark">Inspection Failed</b-badge>
        : Failure to check from the first page of the check or a problem with the system.
        <br>
        * <b-badge variant="primary">Inspecting</b-badge>
        : You can check the real-time status under inspection
        <br>
        <small>(may be displayed if the inspection is not processed, in this case it will be classified as a check failure after a certain period of time) </small>
        <hr>
        <b-table hover striped small responsive="sm" ref="_list" show-empty empty-text="not found" class="table-responsive table_add"
          :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
          <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
          <template slot="fqdn" slot-scope="row">
            <b-img @click="copy(row.item.task_key, site.fqdn)" style="display: inline-block; cursor: pointer;" v-bind="{ width: 15, height: 15 }"  src="ico/copy.ico" alt=""></b-img>
            <b-button variant="link"  style="display: inline-block" :href="'http://'+site.fqdn" target="_blank">
              {{site.fqdn}}
              <b-img src="img/goto_site.png" alt="new Site" v-bind="{ width: 12, height: 12 }"></b-img>
            </b-button>
          </template>
          <template slot="count" slot-scope="row">
            {{ row.item.page_count | number }} ({{ ((row.item.page_count - row.item.ext_count) || 0) | number }} / {{(row.item.ext_count || 0) | number}} / {{(row.item.resource_count || 0)  | number}})
          </template>
          <template slot="created_at" slot-scope="row">
          <!-- 이 부분 데이터 넣는 것 확인 필요 -->
            {{row.item.started_at | datetime}} ~ {{row.item.finished_at | datetime}}
          </template>
          <template slot="status" slot-scope="row">

            <b-badge v-if="row.item.detect_count > 0" variant="danger">Detect <b-badge variant="light">{{ row.item.detect_count | number }}</b-badge></b-badge>
            <b-badge v-else-if="row.item.finished_at && row.item.page_count < 1" variant="dark">Inspection Failed</b-badge>
            <b-badge v-else-if="!row.item.finished_at" variant="info">Inspecting </b-badge>
            <b-badge v-else variant="success">Safety </b-badge>

            <b-badge v-if="row.item.error_count > 0" variant="warning">Error <b-badge variant="light">{{row.item.error_count | number}}</b-badge></b-badge>

            <!-- 400 ~ 500 -->
            <!-- 에러에 대한 추가 설명 필요 -->
          </template>
          <template slot="func" slot-scope="row">
            <b-btn v-if="!row.item.finished_at" @click="sync.task_key = row.item.task_key; timer()"  size="sm" variant="primary">
              <span v-if="sync.status && row.item.task_key == sel_status.task_key" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">&nbsp;</span>
              Inspecting
            </b-btn>
            <b-btn v-else @click="detail(row.item.id)" size="sm" variant="outline-primary">More</b-btn>
            <b-btn v-if="!row.item.finished_at" @click="scan_stop(row.item.task_key)"  size="sm" variant="warning">STOP</b-btn>
          </template>
        </b-table>
        <hr>

        <b-row>
          <b-col md="5">
          </b-col>
          <b-col md="3">
            <b-pagination class="pull-left" size="sm" :total-rows="getRowCount" :per-page="so.perPage" v-model="currentPage" prev-text="<" next-text=">" />
          </b-col>
          <b-col md="4">
            <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> List </b-button>
            <!-- <b-button v-if="sel_status && sel_status.task_key" size="sm" class="float-right text-white mr-2" variant="info" @click="sync.status = !sync.status"> Auto Refresh ({{sync.timer}}) </b-button> -->
          </b-col>
        </b-row>
        <!-- 사이트 점검 정보 -->
      </b-card>
      <!-- 여기서 상세 내용  보여 줘야 함 -->
      <hr v-if="sel_result && sel_result.id && $route.params.site_id">
      <detail v-if="sel_result && sel_result.id && $route.params.site_id" :result_id="sel_result.id" :item="{ fqdn : site.fqdn }"></detail>
      <status v-if="sel_status && sel_status.task_key" :status="sel_status" :refresh_timer="sync.timer" @stop="sync.status = !sync.status"/>
    <!-- </b-card> -->
    <!-- <hr>
    <router-view @refresh="refresh()"></router-view> -->
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
